__webpack_public_path__ = `${Gaia.staticURL}js/bundles/`;

import {polyfill} from 'es6-promise';
polyfill();
